import React, { useEffect, useMemo, useState } from 'react'

// Api
import { getListCategory } from 'api/ticket-support'

// Services
import message from 'services/message'

// Helpers
import { resolveErrorMessage } from 'helpers'

// Use
import { useMounted } from 'use/mounted'

// Models
import { FAQ, HS } from 'models/Category'

// Components
import Row from 'ui/Row'
import Col from 'ui/Col'
import Space from 'ui/Space'
import Loading from 'ui/Loading'
import Text from 'ui/Text'
import CardItem from './ListCategroyItem'

const ListCategory = () => {
  const isMounted = useMounted()

  // State
  const [categories, setCategories] = useState([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)

    getListCategory()
      .then((data) => {
        if (isMounted.current) {
          setCategories(data)
        }
      })
      .catch(async (error) => {
        message.error(await resolveErrorMessage(error))
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [isMounted])

  const hsCategories = useMemo(() => {
    return categories.filter((category) => category.type === HS)
  }, [categories])

  const faqCategories = useMemo(() => {
    return categories.filter((category) => category.type === FAQ)
  }, [categories])

  return (
    <Loading spinning={isLoading}>
      <Space direction="vertical" size={30} style={{ width: '100%' }}>
        <div>
          <Text color="#000000" bold size={18} paddingBottom={0}>
            User manuals
          </Text>
          <Row multiline>
            {hsCategories.map((category) => (
              <Col xl={{ span: 3 }} md={{ span: 4 }} key={category.id}>
                <CardItem category={category} />
              </Col>
            ))}
          </Row>
        </div>
        <div>
          <Text color="#000000" bold size={18} paddingBottom={0}>
            Frequently asked questions
          </Text>
          <Row multiline>
            {faqCategories.map((category) => (
              <Col xl={{ span: 3 }} md={{ span: 4 }} key={category.id}>
                <CardItem category={category} />
              </Col>
            ))}
          </Row>
        </div>
      </Space>
    </Loading>
  )
}

export default ListCategory
